var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-icon',[(_vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_c('v-avatar',{attrs:{"size":"26"}},[_c('span',[_vm._v(_vm._s(_vm._f("first2Char")(_vm.title)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }